import React from 'react';
import Icon from '../Icon';
import styled from 'styled-components';
import Tooltip from '../Tooltip';

const CardHeaderContainer = styled.div`
  display: flex;
  width: 100%;
  min-width: 200px;
  max-height: 150px;
  flex-direction: row;
  align-items: ${(props) =>
    props.alignItems ? props.alignItems : 'flex-start'};
  position: relative;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    flex-direction: row;
    align-items: flex-start;
  }

  .cardHeader {
    display: flex;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: ${(props) => (props.fontSize ? props.fontSize : '28px')};
    color: #1e1f1e;
    flex-direction: ${(props) => (props.iconRight ? 'row-reverse' : 'row')};
    text-transform: ${(props) =>
      props.textTransform ? props.textTransform : 'uppercase'};
    white-space: nowrap;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      flex-wrap: wrap;
      flex-direction: column-reverse;

      .ttPillsContainer {
        margin-right: auto;
        margin-left: 0;
        margin-top: 16px;
      }

      .ttTitle {
        text-align: left;
        white-space: pre-wrap;
      }

      .tlgTitle {
        text-align: left;
        white-space: pre-wrap;
      }
    }
  }

  .leftText {
    text-transform: none;
  }

  .cardHeaderRight {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-left: auto;
    text-transform: none;
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      flex-direction: column;
      justify-content: center;
      margin-left: auto;
    }
  }

  .cardHeaderLeft {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: auto;
    text-transform: none;
  }

  .iconCardHeader {
    width: 28px;
    height: 28px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #adb5bd;
    border-radius: 100%;
    color: white;
    margin-right: 10px;
  }

  .iconOffset {
    color: ${(props) => (props.iconColor ? props.iconColor : 'inherit')};
    ${(props) =>
      props.iconPosition ? 'margin-right: 10px' : 'margin-left: 10px'}
  }

  .tooltipCardHeader {
    margin-bottom: 20px;
    margin-left: 5px;
  }

  .iconCardHeader > svg {
    margin: 0;
  }

  .iconCardHeader {
    margin-right: 10px;
  }

  ${(props) => props.styles}
`;

const CardHeader = (props) => {
  return (
    <CardHeaderContainer
      alignItems={props.alignItems}
      fontSize={props.fontSize}
      iconRight={props.iconRight}
      textTransform={props.textTransform}
      iconColor={props.iconColor}
      styles={props.styles}
    >
      <div className="cardHeader">
        {props.iconContainer ? (
          <div className="iconCardHeader">
            <Icon icon={props.icon} />
          </div>
        ) : (
          props.icon && (
            <div className="iconOffset">
              <Icon icon={props.icon} />
            </div>
          )
        )}

        {props.tooltip && (
          <div className="tooltipCardHeader">
            <Tooltip {...props.tooltip} />
          </div>
        )}

        {typeof title === 'string' ? <h2>{props.title}</h2> : props.title}
      </div>
      {props.rightComponents && (
        <div className="cardHeaderRight">{props.rightComponents}</div>
      )}
    </CardHeaderContainer>
  );
};

export default CardHeader;
